import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientData } from '../../../models';

@Component({
  selector: 'app-patient-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './patient-card.component.html',
})
export class PatientCardComponent {
  readonly patient = input.required<PatientData>();
}
